import type { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { Button } from '@kanda-libs/ks-design-library';

import { URLS } from 'components/shared/App/constants';
import { selectors } from 'store';

const PartnersActions: FunctionComponent = function () {
  const { id } = useSelector(selectors.getPathKey);

  if (!id)
    return (
      <Link to={URLS.partnersFilter.replace(':id', 'kanda')}>
        <Button.Text id="staff-partners-kanda" label="Kanda Direct Sales" />
      </Link>
    );

  return (
    <>
      <Link to={URLS.partners}>
        <Button.Text id="staff-partners-all" label="All partners" />
      </Link>
    </>
  );
};

export default PartnersActions;
